export function copyToClipBoard(content: string, type: string) {
    function handler(event: ClipboardEvent) {
        event.clipboardData?.setData(type, content || '');
        event.preventDefault();
        document.removeEventListener('copy', handler, true);
    }

    document.addEventListener('copy', handler, true);
    document.execCommand('copy');
    document.removeEventListener('copy', handler, true);
}
